import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class ViewAPI {
  
  static list = (success, failure) => {
    fetch(Config.app.link + 'api/view', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/view/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (dist, success, failure) => {
    fetch(Config.app.link + 'api/view', new Header('POST', dist))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/view/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
  
  static clone = (id, success, failure) => {
    fetch(`${Config.app.link}api/view/clone/${id}`,
      new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default ViewAPI;